// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5e628e72","703":"c6162780","787":"3c022a3f"}[chunkId] + ".chunk.js";
};